export const colorPalette = {
  primary: {
    light: '#3b82f6', // blue-500
    main: '#2563eb',  // blue-600
    dark: '#1d4ed8'   // blue-700
  },
  secondary: {
    light: '#f97316',
    main: '#ea580c',
    dark: '#c2410c'
  },
  success: {
    light: '#10b981',
    main: '#059669',
    dark: '#047857'
  },
  warning: {
    light: '#f59e0b',
    main: '#d97706',
    dark: '#b45309'
  },
  error: {
    light: '#ef4444',
    main: '#dc2626',
    dark: '#b91c1c'
  },
  neutral: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    700: '#374151',
    800: '#1f2937',
    900: '#111827'
  }
};

export const typography = {
  h1: 'text-4xl font-extrabold tracking-tight',
  h2: 'text-3xl font-bold tracking-tight',
  h3: 'text-2xl font-semibold',
  h4: 'text-xl font-medium',
  body1: 'text-base',
  body2: 'text-sm',
  caption: 'text-xs'
};

export const spacing = {
  xxs: '0.125rem',  // 2px
  xs: '0.25rem',    // 4px
  sm: '0.5rem',     // 8px
  md: '0.75rem',    // 12px
  lg: '1rem',       // 16px
  xl: '1.5rem',     // 24px
  xxl: '2rem',      // 32px
  xxxl: '3rem',     // 48px
  xxxxl: '4rem'     // 64px
};

export const sectionSpacing = {
  compact: '1.5rem', // 24px
  regular: '2.5rem', // 40px
  spacious: '3.5rem' // 56px
};